// extracted by mini-css-extract-plugin
export var dataCell = "_rb-2";
export var dataRow = "_rb-0";
export var headerRow = "_rb-1";